import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CloudDeployIcon
 * @description
 * Outline cloud glyph with an upward arrow through the middle for
 * deploy/upload-to-cloud signifiers. The cloud's bottom edge has a cutout so
 * it does not intersect the arrow shaft.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const CloudDeployIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="CloudDeployIcon"
      fill="none"
      stroke={
        gradient
          ? "url(#icon-gradient)"
          : props?.stroke
          ? props.stroke
          : "var(--color-theme-600)"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-3.535M9 18h-2.343" />
      <path d="M12 20v-8" />
      <path d="M9.5 14.5l2.5 -2.5l2.5 2.5" />
    </svg>
  )
);
CloudDeployIcon.displayName = "CloudDeployIcon";
export default CloudDeployIcon;
